require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-and-geospatial-tools.json") })
        }
      }, "path---data-and-geospatial-tools");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-and-geospatial-tools!./.cache/json/data-and-geospatial-tools.json
// module id = 366
// module chunks = 231608221292675